import React from 'react';
import { ActivityEditorProps } from '../types';
import { useQuizEditor } from './useQuizEditor';
import ActivityHeaderEditor from './ActivityHeaderEditor';
import QuestionItem from './QuestionItem';
import QuizActions from './QuizActions';
import AiChatDialog from '../../../../ai-agent/AiChatDialog';
import { renderQuizPreview } from '../../../../ai-agent/previewRenderers';

// Quiz Editor Component
const QuizEditor: React.FC<ActivityEditorProps> = (props) => {
  const {
    // State
    questions,
    editingQuestionId,
    quizTitle,
    quizDescription,
    isDragging,
    isSaving,
    saveError,
    showQuestionTypeModal,
    dropdownPosition,
    showAiDialog,
    
    // Refs
    dropdownRef,
    
    // Actions
    setEditingQuestionId,
    setQuizTitle,
    setQuizDescription,
    setShowAiDialog,
    handleShowQuestionTypeModal,
    handleAddQuestion,
    updateQuestion,
    handleDeleteQuestion,
    handleDuplicateQuestion,
    handleDragStart,
    handleDragOver,
    handleDragEnd,
    changeQuestionType,
    handleSaveQuiz,
    handleAiGeneratedContent,
    setShowQuestionTypeModal,
  } = useQuizEditor(props);

  return (
    <div className="space-y-6">
      {/* Activity Header */}
      <ActivityHeaderEditor
        title={quizTitle}
        description={quizDescription}
        activityType="Quiz"
        onTitleChange={setQuizTitle}
        onDescriptionChange={setQuizDescription}
        titlePlaceholder="Quiz Title"
        descriptionPlaceholder="Quiz Description"
      />

      {/* Questions List */}
      <div className="space-y-4">
        {questions.map((question, index) => (
          <QuestionItem
            key={question.id}
            question={question}
            index={index}
            isEditing={editingQuestionId === question.id}
            isDragging={isDragging}
            onEdit={() => setEditingQuestionId(question.id)}
            onUpdate={(updates) => updateQuestion(question.id, updates)}
            onTypeChange={(newType) => changeQuestionType(question.id, newType)}
            onDone={() => setEditingQuestionId(null)}
            onDuplicate={() => handleDuplicateQuestion(question.id)}
            onDelete={() => handleDeleteQuestion(question.id)}
            onDragStart={(e) => handleDragStart(e, question.id)}
            onDragOver={(e) => handleDragOver(e, question.id)}
            onDragEnd={handleDragEnd}
          />
        ))}
      </div>

      {/* Quiz Actions */}
      <QuizActions
        questionsCount={questions.length}
        isSaving={isSaving}
        saveError={saveError}
        onShowQuestionTypeModal={handleShowQuestionTypeModal}
        onSaveQuiz={handleSaveQuiz}
        showQuestionTypeModal={showQuestionTypeModal}
        dropdownPosition={dropdownPosition}
        dropdownRef={dropdownRef}
        onSelectQuestionType={handleAddQuestion}
        onCloseQuestionTypeModal={() => setShowQuestionTypeModal(false)}
      />
      
      
    </div>
  );
};

export default QuizEditor; 